// istanbul ignore file

import { CreditLine } from '@visa/shared/interfaces'

export enum HomeOwnership {
  Rental = 'Lejebolig',
  OwnerOccupiedHousing = 'Ejerbolig',
  CorporativeHousing = 'Andelsbolig',
  HolidayHome = 'Fritidsbolig',
  NoPermanentPlaceOfResidence = 'Uden fast bopæl',
}

export enum Purpose {
  OtherDebt = 'Anden gæld',
  Dentist = 'Tandlæge',
  Travel = 'Rejse',
  Bills = 'Regninger',
  Consumption = 'Forbrug',
  Medicine = 'Medicin',
}

export enum MaritalStatus {
  Married = 'Gift',
  Unmarried = 'Eneboende',
  InCohabitation = 'Samlevende',
}

export enum LowHouseCostReason {
  HousingReducedFromSalary = 'HousingReducedFromSalary',
  IncludedInLoanCost = 'IncludedInLoanCost',
  LivingWithFamily = 'LivingWithFamily',
  LivingWithFriend = 'LivingWithFriend',
  OwnValue = 'OwnValue',
  PartnerPaysForHousing = 'PartnerPaysForHousing',
  PayingRentInCash = 'PayingRentInCash',
  PaymentInAnotherAccount = 'PaymentInAnotherAccount',
  TransferredUsingMobilePay = 'TransferredUsingMobilePay',
}

export interface RenewCustomerDetailsResponseDto {
  loan: CreditLine
}

export enum BankLoginMethods {
  mitid = 'mitid',
}

export enum AccountLetterPaymentStatuses {
  NotPaidInTime = 'NotPaidInTime',
  NotYetDue = 'NotYetDue',
  PaidInTime = 'PaidInTime',
}

export enum InvoicesTypes {
  Cancellation = 'Cancellation',
  Termination = 'Termination',
  Invoice = 'Invoice',
  Reminder = 'Reminder',
}

export enum AppStatus {
  dashboard = 'dashboard',
  declined = 'declined',
  newApp = 'new',
  pending = 'pending',
  resubmit = 'resubmit',
  resume = 'resume',
}

export type ListOfValues = 'loan_purpose' | 'marital_status' | 'household_type' | 'cars'
export interface ListOfValuesItem {
  id: string
  lov_code: string
  lov_label: string
}
export interface ListOfValuesResponseDto {
  key: ListOfValues
  values: ListOfValuesItem[]
}

export enum InvoiceStatuses {
  Paid = 'Paid',
  Other = 'Other',
}
